import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { KanbanStrategyService } from '../../plugins/tracker/services/kanban.strategy.service';
import * as _ from 'lodash';

@Component({
  selector: 'gf-card-board',
  template: require('./gf-card-board.component.html'),
})
export class GfCardBoardComponent implements OnInit, OnChanges {
  @Input() options: any;
  @Input() items: any;
  
  @Output() onUpdateItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEditItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddItem: EventEmitter<any> = new EventEmitter<any>();

  data: any = false;
  sortExpr: string = '';
  filteredColumns: any = [];
  filteredDataRows: any = [];
  draggingCard: any;
  addBox: any;
  draggingOverCol: any;

  constructor(private kanbanStrategyService: KanbanStrategyService) {}

  ngOnInit(): void {
    this.sortExpr = this.getSort(this.options);
    this.data = this.getData();
    this.setupFilteredData();
  }

  ngOnChanges(changes: any): void {
    // Set things up only when options is set or changes,
    // so that row.isClosed persists between fetches/paging.
    if (changes.options && !changes.options.isFirstChange()) {
      this.data = this.getData();
    } else if (changes.items && !changes.items.isFirstChange()) {
      this.data = this.getData(this.data);
    }

    this.setupFilteredData();
  }

  setupFilteredData() {
    this.filteredColumns = _.filter(this.options.columns.items, {hidden: false});
    this.filteredDataRows = _.filter(this.data.rows, {hidden: false});
  }

  getVisibleCount(items: any): number {
    return _.filter(items, { hidden: false }).length;
  }

  private getData(src: any = null): any {
    const srcRows = _.get(src, 'rows', _.get(this.options, 'rows.items', []));

    const rowData = _.map(srcRows, (row) => {
      row.cols = this.kanbanStrategyService.getColumnDataForRow(row, this.options, this.items);
      return row;
    });

    const ret = this.kanbanStrategyService.setColumnTotals({
      rows: this.kanbanStrategyService.setRowTotals(rowData)
    });

    if (!src) {
      this.options = this.kanbanStrategyService.collapseBySetting(this.options, ret);
    }

    return ret;
  }

  private getSort(options: any): string {
    const sortPath = _.get(options, 'sortProperty', 'id');
    const sortDir = _.get(options, 'sortDirection', 'asc');
    return (sortDir.toLowerCase() === 'asc') ? '' : `-${sortPath}`;
  }

  trackByCardId(index: number, card: any): any {
    return card.id;
  }

  onDropped($event: any, row: any, col: any) {
    $event.preventDefault();
    
    if (!this.options.canUpdate || !this.draggingCard) return;

    this.draggingOverCol = null;
    this.onUpdateItem.emit({card: this.draggingCard, col: col, row: row});
    this.draggingCard = null;
  }

  enterDragover($event, colId: any) {
    if (this.draggingCard) {
      $event.preventDefault();
      this.draggingOverCol = colId;
    }
    return true;
  }

  exitDragover($event) {
    if (this.draggingCard) {
      this.draggingOverCol = null;
    }
  }

  onDrag(card: any) {
    this.draggingCard = card;
  }

  editMethod = ($event: any) => {
    this.onEditItem.emit($event);
  }

  setMouseEnterDroppable(rowId, colId) {
    if (!this.options.canUpdate) return;
    this.addBox = rowId + '-' + colId;
  }

  setMouseLeaveDroppable() {
    this.addBox = false;
  }

  isDraggingOver(colId: any) {
    return (this.draggingOverCol == colId)
  }

  menuMethod = (params) => {
    this.onUpdateItem.emit({card: params.card, col: params.col, row: params.row});
  }
}
